import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'

import { palette } from '../constants'
import Text from './Text'

export default styled(Text.withComponent('a'))`
  color: ${palette.skyBlue2};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${darken(0.1, palette.skyBlue2)};
  }
`
